import { render, staticRenderFns } from "./ResearchProjectActForm.vue?vue&type=template&id=d7370464&scoped=true"
import script from "./ResearchProjectActForm.vue?vue&type=script&lang=js"
export * from "./ResearchProjectActForm.vue?vue&type=script&lang=js"
import style0 from "./ResearchProjectActForm.vue?vue&type=style&index=0&id=d7370464&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7370464",
  null
  
)

export default component.exports